var Backbone = require('backbone');

var videoUtils = require('front/utils/video');
require('./VideoRecentItem.less');
var VimeoPlayer = require('@vimeo/player');

var PROVIDER = {
    YOUTUBE: 'youtube',
    VIMEO: 'vimeo',
    RUTUBE: 'rutube'
};

module.exports = Backbone.View.extend({
    events: {
        'click .VideoRecentItem-img': 'playVideo'
    },

    initialize: function () {
        this.$img = this.$('.VideoRecentItem-img');
        this.$video = this.$('.VideoRecentItem-video');

        this.provider = this.$el.data('provider');
        this.embedCode = this.$el.data('embed-code');
        this.aspectRatio = this.$el.data('aspect-ratio');

        this.player = null;
        this.playerInitialized = false;
        this.playerReady = false;
        this.playerPlaying = false;

        this.on('VideoRecentItem-leave', function () {
            if (this.player && this.playerReady && this.playerPlaying) {
                this.stopVideo();
            }
        }.bind(this));
    },

    initPlayer: function () {
        this.$video.html(this.embedCode);
        this.$iframe = this.$video.find('iframe');

        if (this.provider === PROVIDER.YOUTUBE) {
            if (window.app.state.youtubePlayerAPIReady) {
                this.onYoutubePlayerAPIReady();
            } else {
                window.app.vent.on('youtube-ready', this.onYoutubePlayerAPIReady.bind(this));
            }
        } else if (this.provider === PROVIDER.VIMEO) {
            this.player = new VimeoPlayer(this.$iframe);
            this.playerReady = true;
            this.player.on('play', this.onVimeoPlayerReady.bind(this));
        } else if (this.provider === PROVIDER.RUTUBE) {
            this.onRutubePlayerReady();
        }

        this.playerInitialized = true;
    },

    stopVideo: function () {
        if (this.player && this.playerReady && this.playerPlaying) {
            if (this.provider === PROVIDER.YOUTUBE) {
                this.player.pauseVideo();
            } else if (this.provider === PROVIDER.VIMEO) {
                this.player.pause();
            } else if (this.provider === PROVIDER.RUTUBE) {
                this.$iframe[0].contentWindow.postMessage(JSON.stringify({
                    type: 'player:pause',
                    data: '{}'
                }), '*');
            }
        }
    },

    playVideo: function () {
    },

    onYoutubePlayerAPIReady: function () {
        this.player = new YT.Player(this.$iframe[0], {
            events: {
                onReady: function (e) {
                    this.playerReady = true;
                }.bind(this),
                onStateChange: function (e) {
                    if (e.data === 1 || e.data === 3) {
                        this.playerPlaying = true;

                        $.Velocity(this.$img[0], 'fadeOut');
                    }
                }.bind(this)
            }
        });
    },

    onVimeoPlayerReady: function () {
        this.playerPlaying = true;

        $.Velocity(this.$img[0], 'fadeOut');
    },

    onRutubePlayerReady: function () {
        window.addEventListener('message', function (e) {
            if (e.source === this.$iframe[0].contentWindow) {
                var message = JSON.parse(e.data);

                if (message.type === 'player:ready') {
                    this.playerReady = true;
                    this.player = true;
                } else if (message.type === 'player:changeState' && message.data.state === 'playing') {
                    this.playerPlaying = true;

                    $.Velocity(this.$img[0], 'fadeOut');
                }
            }
        }.bind(this));
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/VideoRecentItem/VideoRecentItem.js
// module id = 178
// module chunks = 0